import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { isRtl } from '@trackizy/i18n/rtl';
import { localeLoaders } from '@trackizy/i18n/loaders';

// Locales are fetched on demand (TASK-478): each is its own chunk instead of
// all three riding in the entry bundle. i18next asks this backend for every
// language in the resolution chain (the active one plus the `en` fallback)
// before init — and before every changeLanguage — resolves, so a switch never
// applies a language whose strings are not there yet. Codes we do not ship
// (`en-US`, `fr`) resolve to an empty bundle and fall through to `en`.
const lazyLocaleBackend = {
  type: 'backend',
  init() {},
  read(language, _namespace, callback) {
    const load = localeLoaders[language];
    if (!load) {
      callback(null, {});
      return;
    }
    load().then((mod) => callback(null, mod.default), (err) => callback(err, null));
  },
};

const updateDirection = (lng) => {
  document.documentElement.dir = isRtl(lng) ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
};

i18n.on('languageChanged', updateDirection);

// Top-level await: nothing that imports this module (main.jsx, trackizy.js)
// evaluates until the detected locale and the `en` fallback are loaded, so the
// first render never shows raw keys. A failed chunk fetch still resolves init
// (i18next logs it), so the app renders on the t() defaults instead of hanging.
await i18n
  .use(lazyLocaleBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
  });

updateDirection(i18n.language);

export default i18n;
